import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IPiecesDataTableRowFormMeta {
    hopper: FormInputMeta;
    value: FormInputMeta;
    currency: FormInputMeta;
    active: FormInputMeta;

    schema: any;
}

const piecesDataTableRowFormMeta = {} as IPiecesDataTableRowFormMeta;

piecesDataTableRowFormMeta.hopper = {
    name: "hopper",
    type: "select",
    label: "Hopper",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !"),
};

piecesDataTableRowFormMeta.value = {
    name: "value",
    type: "number",
    label: "Valeur",
    placeholder: "",
    validation: yup.number().required("Champ obligatoire !"),
};

piecesDataTableRowFormMeta.currency = {
    name: "currency",
    type: "text",
    label: "Devise",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !"),
};

piecesDataTableRowFormMeta.active = {
    name: "active",
    type: "checkbox",
    label: "Actif",
    placeholder: "",
    validation: yup.boolean()
};


piecesDataTableRowFormMeta.schema = yup.object().shape(getValidationSchema(piecesDataTableRowFormMeta));

export default piecesDataTableRowFormMeta;